export default __webpack_public_path__ + "static/media/(75).423e47c1.jpg";